module.exports = __webpack_public_path__ + "static/media/project-thumbnail10.903eda36.jpg";